export default [
    {
        title: '笔记管理',
        path: '/note',
        name: 'noteManagement',
        meta: {
            key: 'note',
            open: 'note'
        },
        permission: 'noteManagement',
        menu: true,
        children: [
            {
                title: '笔记列表',
                path: '/note/list',
                name: 'noteList',
                component: () => import('@/views/note/list'),
                meta: {
                    key: 'noteList',
                    open: 'note'
                },
                permission: 'noteList',
                menu: true,
                children: [
                    {
                        title: '笔记详情',
                        path: '/note/list/detail/:id',
                        name: 'noteDetail',
                        component: () => import('@/views/note/detail'),
                        meta: {
                            key: 'noteList',
                            open: 'note'
                        },
                        permission: false
                    },
                    {
                        title: '添加笔记',
                        path: '/note/list/edit',
                        name: 'noteAdd',
                        component: () => import('@/views/note/edit'),
                        meta: {
                            key: 'noteList',
                            open: 'note'
                        },
                        permission: false
                    },
                    {
                        title: '编辑笔记',
                        path: '/note/list/edit/:id',
                        name: 'noteEdit',
                        component: () => import('@/views/note/edit'),
                        meta: {
                            key: 'noteList',
                            open: 'note'
                        },
                        permission: false
                    },
                    {
                        title: '导入笔记',
                        path: '/note/list/import',
                        name: 'noteImport',
                        component: () => import('@/views/note/import'),
                        meta: {
                            key: 'noteList',
                            open: 'note'
                        },
                        permission: false
                    }
                ]
            },
            {
                title: '评论列表',
                path: '/note/comment',
                name: 'noteComment',
                component: () => import('@/views/note/comment'),
                meta: {
                    key: 'noteComment',
                    open: 'note'
                },
                permission: 'noteComment',
                menu: true
            }
        ]
    }
];
